import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import RpTable from 'rp-react-table';
import Svg from 'rp-react-svg-icon';
import columns from './columns';
import { sortByDate } from '../../utils/date';

class RaceDays extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            data: props.data.sort(sortByDate('raceDate', true)),
        };
    }

    toggle = () => {
        this.setState({
            expanded: !this.state.expanded,
        });
    }

    render() {
        const { params: { name, id } } = this.props;
        const { expanded, data } = this.state;
        const slicedData = expanded ? data : data.slice(0, 5);
        const iconName = expanded ? 'up' : 'down';

        return (
            <div className="cp-raceDays">
                <h2 className="cp-raceDays__title">
                    Upcoming Racedays
                </h2>
                <RpTable
                    data={slicedData}
                    columns={columns(name, id)}
                    uiType={5}
                    noDataText="No upcoming racedays"
                />
                {data && data.length > 5 &&
                    <button
                        className="ui-btn"
                        onClick={this.toggle}
                    >
                        <Svg
                            key={iconName}
                            iconName={iconName}
                            size="Medium"
                        />
                    </button>
                }
            </div>
        );
    }
}

RaceDays.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        raceDate: PropTypes.string,
        raceDatetimeFirst: PropTypes.string,
        raceDatetimeLast: PropTypes.string,
    })).isRequired,
    params: PropTypes.shape({
        name: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
    }).isRequired,
};

export default RaceDays;



// WEBPACK FOOTER //
// ./src/js/course/raceDays/RaceDays.jsx